import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import ReloadIcon from '@mui/icons-material/Replay';

import { useTheme } from 'contexts/ThemeContext';

import { Button } from 'components/Inputs';
import { Container, Item, Row } from 'components/Layout';
import { Loading } from 'components/Loading';

export const ButtonCreate = props => {
  const {
    justify = 'flex-end',
    disabled,
    children,
    fontColor,
    reload = false,
    IconComponent,
    loading,
    buttonBorderColor = null,
    ...rest
  } = props;
  const { themeColors } = useTheme();

  const Icon = IconComponent || (reload ? ReloadIcon : AddIcon);
  const color = disabled
    ? themeColors.keepDark
    : fontColor || themeColors.keep_light;
  return (
    <Container>
      <Row spacing={0}>
        <Item justify={justify}>
          <Button
            variant="contained"
            disabled={disabled}
            justify={justify}
            fontColor={fontColor}
            reload={reload}
            IconComponent={IconComponent}
            loading={loading}
            {...rest}
            style={{
              fontWeight: 600,
              ...(buttonBorderColor
                ? { border: `1px solid ${buttonBorderColor}` }
                : {})
            }}
            startIcon={
              loading ? (
                <Loading color={color} width="20px" />
              ) : (
                <Icon
                  style={{
                    color
                  }}
                />
              )
            }
          >
            {children || 'Ajouter'}
          </Button>
        </Item>
      </Row>
    </Container>
  );
};

export default ButtonCreate;
